<template>
    <div>
        <div class="VueTables__primary-content-bold">
            <inline-svg
                class="VueTables__primary-content-icon-wrapper"
                :url="require('../../../../images/actions/lock.svg')"
                classes="VueTables__primary-content-icon"
                v-if="!data.is_active"
                v-tippy
                :title="trans('tooltips.notes.user_locked')"
            >
            </inline-svg>

            {{data.full_name_reversed}}
        </div>

        <div class="VueTables__secondary-content">{{ data.username }}<br/>{{ data.email }}</div>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js';

    export default {
        props: ['data', 'index', 'column'],

        components: {
            InlineSvg,
        },
    }
</script>
